module.exports = __webpack_public_path__ + "static/media/frame-red.e5036a3a.svg";